<div #contentDiv class="max-w-lg mx-auto flex-col pt-20 text-theme-text">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-[calc(100vh-5rem)]">

    <!-- Header -->
    <div class="flex flex-row pt-6 px-4 pb-4 items-center justify-center relative">
      <div class="absolute left-4" *ngIf="showBackButton">
        <app-circle-button class="hover:bg-gray-100" [icon]="'fa-arrow-left'" size="12" type="solid" fontSize="xl" (onClick)="backClicked()"></app-circle-button>
      </div>
      <div class="text-3xl break-words text-center">
        {{(livesplitTable && splitType === 'livesplit' && page === 1) ?
        livesplitTable : (splitType === 'chat'?getString("Betala din nota"):getString("Betala notan"))}}
      </div>
    </div>

    <!-- Sub Header -->
    <div *ngIf="!nothingToPay && livesplitTable && splitType === 'livesplit' && page === 1"
          class="text-xl text-theme-text font-bold text-center py-4">
      {{getString("Välj det du skall betala")}}
    </div>

    <!-- Main Content -->
    <div class="px-8" *ngIf="!isLoading">

      <!-- Nothing to Pay Message -->
      <div *ngIf="nothingToPay" class="mt-10 p-8 bg-theme-surface2 rounded-xl">
        <ng-container *ngIf="!showThereAreOtherItemsToPay">
          <p class="">{{getString(translate.ALL_IS_PAID1)}}</p>
          <p class="mt-4">{{getString(translate.ALL_IS_PAID2)}}</p>
        </ng-container>
        <ng-container *ngIf="showThereAreOtherItemsToPay">
          <p class="">{{getString(translate.ALL_IS_PAID_MORE)}}</p>
          <div class="mt-8">
            <app-light-icon-button [icon]="'fa-arrow-right'" [text]="getString('Se hela notan')" (onClick)="activateSplit()"></app-light-icon-button>
          </div>
        </ng-container>
      </div>

      <!-- LiveSplit Content -->
      <div *ngIf="!nothingToPay && page===1 &&  splitType==='livesplit'" class="mt-4">
        <div *ngFor="let group of groups" class="mb-8">

          <!-- Group Header -->
          <div class="flex items-center py-2 border-b border-theme-divider justify-between">
            <div class="text-lg font-bold">{{ group.name }}</div>
            <button *ngIf="group.items.length>1" (click)="selectAll(group)" class="text-sm flex">
              <div class="ml-2">{{!group.selected?getString("Välj alla"):getString('Avmarkera valda')}}</div>
            </button>
          </div>

          <!-- Group Hint -->
          <div *ngIf="group.hint" class="text-sm text-theme-text3 mt-2">{{ group.hint }}</div>

          <!-- Group Items -->
          <div *ngFor="let item of group.items" class="mt-4">

            <div *ngIf="shouldItemBeVisible(item)">
              <div class="flex space-x-3 w-full cursor-pointer items-center" [class.opacity-30]="!item.canChange">
                <div class="mt-0.5">
                  <app-box-for-checkbox [disabled]="!item.canChange" [(ngModel)]="item.selected" (change)="itemSelected(item)"></app-box-for-checkbox>
                </div>
                <div class="flex-1 min-w-0" (click)="itemToggled(item)">
                  <div class="text-base flex">
                    <div class="w-[calc(100%-4rem)] text-theme-text font-bold">
                      <span *ngIf="!item.parts && item.count>1">{{item.count}}x </span>
                      <span *ngIf="item.parts">{{item.count}}/{{item.parts}} </span>
                      <span class="break-words">{{item.name}}</span>
                    </div>
                    <div class="ml-2 flex-1 whitespace-nowrap text-end">
                      <span *ngIf="item.comment" class="text-theme-text3"> - {{ item.comment }}</span>
                      <span class="text-theme-text3 tabular-nums">{{getPrice(item)}} {{currencySymbol}}</span>
                    </div>
                  </div>
                  <div *ngFor="let line of packageDetailsByRid[item.rid]" class="text-sm/5 text-theme-text3 break-words">{{line}}</div>
                </div>
              </div>

              <!-- Item Status -->
              <div *ngIf="item.state === 'reserved'"
                   [class]="item.canChange ? 'text-theme-text2' : 'text-theme-text3'"
                   class="mt-1 text-sm pl-8 flex h-7">
                <div>{{getString("Reserverad av")}}</div>
                <div *ngIf="item.user_id != 0" class="ml-1">{{getUserName(item)}}</div>
                <div *ngIf="item.rid===lastRid && item.parts === undefined" class="ml-2">
                  <app-link-button [text]="getString('(Dela)')" (onClick)="splitItems(item)" [font]="'font-medium'" [color]="'text-theme-text'"></app-link-button>
                </div>
              </div>

              <div *ngIf="item.state === 'paid'" class="mt-1 text-sm pl-8 h-7 text-theme-text3">
                <span *ngIf="item.user_id">{{getString("Betalad av")}} {{getUserName(item)}}</span>
              </div>

              <div *ngIf="item.state !== 'reserved' && item.state !== 'paid'" class="mt-1 h-7">
                <!-- empty to take up space when not reserved -->
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Chat Receipt -->
      <div *ngIf="page===1 && (splitType==='chat' || splitType==='pl')" class="mt-4">
        <div *ngFor="let item of chatItems" class="py-2">
          <div class="flex items-center justify-between">
            <div class="text-base">
              {{item.count}}<span *ngIf="item.parts">/{{item.parts}}</span>x {{item.name}}
              <span *ngIf="item.comment" class="text-theme-text3"> - {{ item.comment }}</span>
            </div>
            <div class="text-theme-text3 tabular-nums">{{getPrice(item) | number:'1.2-2'}} {{currencySymbol}}</div>
          </div>
          <div *ngFor="let line of chatPackageDetailsByRid[item.rid]" class="ml-4 text-sm/5 text-theme-text3 break-words">{{line}}</div>

          <!-- Included/mandatory attributes nested under their parent -->
          <div *ngFor="let child of chatChildrenByRid[item.rid]"
               class="ml-4 pl-3 mt-1 border-l-2 border-theme-text3/30 flex flex-row items-center justify-between">
            <div class="flex flex-row items-center text-sm text-theme-text2">
              <i class="fas fa-plus text-xs text-theme-text3 mr-2"></i>
              <span>{{child.count}}x {{child.name}}</span>
              <span *ngIf="child.comment" class="text-theme-text3 ml-1"> - {{ child.comment }}</span>
            </div>
            <div class="text-theme-text3 tabular-nums">{{getPrice(child) | number:'1.2-2'}} {{currencySymbol}}</div>
          </div>
        </div>
      </div>

      <!-- TIP SELECTION -->
      <div *ngIf="showTip && (singlePage || page===2) && receiptKey==null && !isFreeDiscountedReceipt">
        <app-tip-selection
          [amount]="amount!"
          [config]="tipConfig"
          [selectedTip]="tipButtonId"
          (onTipChange)="handleTipChange($event)">
        </app-tip-selection>
      </div>

      <!-- Discount code add -->
      <div *ngIf="!nothingToPay && page===2 && show_discount" class="flex flex-col my-4">
        <app-separator></app-separator>
        <div class="flex flex-row items-center mt-4">
          <div class="flex-1 text-lg text-theme-text2 font-bold">{{getString("Rabatt")}}</div>
          <app-light-icon-button *ngIf="!discountApplied()" icon="fa-circle-plus" (onClick)="showDiscountDialog()" [text]="getString('Lägg till')"></app-light-icon-button>
          <div *ngIf="discountApplied()" class="text-lg tabular-nums font-medium">-{{discountAmount()}}</div>
        </div>
        <div class="flex justify-end">
          <div *ngIf="discountApplied()" class="text-sm text-theme-text3 cursor-pointer underline" (click)="showDiscountDialog()">{{getString('Ändra')}}</div>
        </div>
      </div>

      <div *ngIf="!nothingToPay && page===2 && loyaltyInfo" class="mt-10">
        <app-loyalty-info
          [loyaltyInfo]="loyaltyInfo"
          [activeCode]="activeCode"
          [discountFormatted]="discountAmount()"
          (activateDiscountCode)="activateLoyaltyDiscount($event)"
          (activateReward)="activateLoyaltyReward($event)">
        </app-loyalty-info>
        <app-separator></app-separator>
      </div>

      <!-- Total Section -->
      <div *ngIf="!nothingToPay" class="mt-6 pt-4">
        <div class="grid grid-cols-[1fr_auto] gap-x-2">
          <!-- Remaining amount row -->
          <div *ngIf="left > 0" class="text-end text-sm text-theme-text3">
            {{getString("kvar på notan")}}:
          </div>
          <div *ngIf="left > 0" class="text-end text-sm text-theme-text3 tabular-nums">
            {{leftFormatted}}
          </div>

          <!-- Reserved by other guests, not yet paid -->
          <div *ngIf="reservedByOthers > 0" class="text-end text-sm text-theme-text3">
            {{getString("reserverat av andra")}}:
          </div>
          <div *ngIf="reservedByOthers > 0" class="text-end text-sm text-theme-text3 tabular-nums">
            {{reservedByOthersFormatted}}
          </div>

          <!-- Total amount row -->
          <div class="text-end text-lg">
            {{getString("Totalt")}}:
          </div>
          <div class="text-end text-lg font-bold tabular-nums">
            {{priceFormatted}}
          </div>
        </div>
      </div>

      <!-- Inline donations -->
      <!-- TODO: Show inlinedonations when appearance is decided -->
      <!-- <div *ngIf="inlineDonations && inlineDonations.length > 0 && !nothingToPay && page===2" class="mt-6">
        <app-inline-donations
          [inlineDonations]="inlineDonations"
          (selectedChange)="selectedChange($event)"
          [attrValues]="attrValues"
          [(selectedItems)]="selectedItems">
        </app-inline-donations>
      </div> -->

      <!-- Split and next page button -->
      <!--
        Bottom bar visibility: shown whenever there's something to pay on page 1.
        Independent of singlePage (tip/discount). showSplitButton controls "Dela notan".

        | splitType   | allowSplit | Bottom bar | Buttons                  |
        |-------------|------------|------------|--------------------------|
        | pl / chat   | true       | Shown      | Dela notan + Betala      |
        | pl / chat   | false      | Shown      | Betala                   |
        | livesplit   | —          | Shown      | Betala                   |

        singlePage only affects payment page:

        | splitType   | showTip | show_discount | singlePage | Flow                                  |
        |-------------|---------|---------------|------------|---------------------------------------|
        | pl / chat   | F       | F             | true       | Payment methods inline on page 1      |
        | pl / chat   | T       | F             | false      | Page 2: Tip + Payment                 |
        | pl / chat   | F       | T             | false      | Page 2: Discount + Payment            |
        | pl / chat   | T       | T             | false      | Page 2: Tip + Discount + Payment      |
        | livesplit   | F       | F             | false      | Page 2: Payment (always separate)     |
        | livesplit   | T       | F             | false      | Page 2: Tip + Payment                 |
        | livesplit   | F       | T             | false      | Page 2: Discount + Payment            |
        | livesplit   | T       | T             | false      | Page 2: Tip + Discount + Payment      |
      -->
      <div *ngIf="page===1 && amount > 0">
        <!-- Width follows the text: translations ("Se hele regningen") are longer than the Swedish -->
        <div *ngIf="allowSplit && showThereAreOtherItemsToPay" class="pb-4 w-fit min-w-48 mx-auto mt-12 whitespace-nowrap">
          <app-plain-button text="{{getString(splitButtonTitle)}}" (onClick)="activateSplit()" bgColor="bg-theme-surface2-50" font="font-medium"></app-plain-button>
        </div>

        <div *ngIf="!singlePage || showSplitButton" class="max-w-lg mx-auto fixed bottom-0 left-0 right-0 p-4 pb-safe animate-fadein animate-duration-300 z-20 pointer-events-none">
          <div class="pointer-events-auto flex flex-row gap-4">
            <!-- Equal halves, but the split button's text stays on one line: a translation longer than the Swedish
                 "Dela notan" widens it and the pay button shrinks instead of the text wrapping -->
            <app-border-icon-button *ngIf="showSplitButton" class="flex-1 whitespace-nowrap" text="{{getString('Dela notan')}}" (onClick)="activateSplit()" icon="fa-split"></app-border-icon-button>
            <app-action-button class="flex-1" text="{{getString('Betala')}}" (onClick)="nextPage()" [itemCount]="0"
                               [disabled]="splitType==='livesplit' && amount <= 0" icon="fa-wallet" [chevron]="false"></app-action-button>
          </div>
        </div>
      </div>

      <div *ngIf="(singlePage && !showSplitButton) || page===2" class="mt-10 -mx-4">
        <!-- Fully discounted receipt: complete without payment (standard CTA, same look as the payment buttons) -->
        <div *ngIf="isFreeDiscountedReceipt && !nothingToPay" class="px-4">
          <app-action-button icon="fa-check" [text]="getString('Slutför')" (onClick)="pay('free')" [chevron]="false"></app-action-button>
        </div>
        <app-payment-selector *ngIf="appState && !nothingToPay && !isFreeDiscountedReceipt"
          [appState]="appState!"
          (onSelect)="pay($event)"
          (onDirectPaymentComplete)="handleDirectPaymentComplete($event)"
          (onDirectPaymentFailed)="handleDirectPaymentFailed($event)"
          [livesplit]="true"
          [disabled]="tipAmount==null"
          [totalSek]="amount + (tipAmount ?? 0)"
          [tipParam]="'v' + (tipAmount ?? 0)"
          [chargeItems]="chargeItemsForDirect"
          [plKey]="plKeyForDirect"
          [itemRefs]="itemRefsForDirect"
          [receiptKey]="receiptKeyForDirect"></app-payment-selector>
      </div>

      <!-- Terms Link. Norwegian venues: a sentence in the guest's language, since Vipps requires the guest to accept
           the terms before paying. The terms page itself follows the venue language. -->
      <div *ngIf="!nothingToPay && page !== 1 && !isFreeDiscountedReceipt" class="flex h-20">
        <div *ngIf="venueLang === 'no'; else termsLink" class="flex-1 flex items-center justify-center text-sm text-theme-text3">
          <span class="mr-1">{{ getString('Genom att betala godkänner du') }}</span>
          <app-link-button [text]="getString('köpvillkoren')" (onClick)="terms()" [font]="'font-medium'" [color]="'text-theme-text3'"></app-link-button>
        </div>
        <ng-template #termsLink>
          <div class="flex-1 flex items-center justify-center">
            <app-link-button [text]="getString('köpvillkor')" (onClick)="terms()" [font]="'font-medium'" [color]="'text-theme-text3'"></app-link-button>
          </div>
        </ng-template>
      </div>

      <!-- Footer -->
      <div *ngIf="splitType==='livesplit'" class="text-center text-sm pb-8 mt-12 text-theme-text3">
        heynow livesplit™
      </div>
      <!-- Add extra padding when floating button is used -->
      <div *ngIf="page===1 && amount > 0 && (!singlePage || showSplitButton)" class="h-16"></div>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading || isSending" class="fixed inset-0 flex items-center justify-center">
    <app-loading-spinner size="2xl"></app-loading-spinner>
  </div>

  <!-- Div used for form-posting to Bambora for require3D -->
  <div id="formPostDivLS"></div>
</div>
